var _classCallCheck = require("/Users/pietvandeput/WebstormProjects/tetris-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/pietvandeput/WebstormProjects/tetris-react/node_modules/@babel/runtime/helpers/createClass");

var Shape = require('./shape').Shape;

var ShapeDimension = require('./shape').ShapeDimension;

var tetraShapes = require('./tetra-shapes');
/**
 * Implements the engine of a game
 */


var Engine =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * Initializing new area
   * @param {number} width is the width of the field of the game in squares
   * @param {number} height is the height of the field of the game in squares
   * @param {function} renderHandle The method that will be runned every time 
   *                   when game state will be changed. Receives game render data.
   * @param {Array} default heap for a game
   */
  function Engine() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var renderHandle = arguments.length > 2 ? arguments[2] : undefined;
    var defaultHeap = arguments.length > 3 ? arguments[3] : undefined;
    var additionalShapes = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, Engine);

    if (width <= 0 || height <= 0) throw 'Size parameters of the game field are incorrect';
    this.width = width;
    this.height = height;
    this._shapesSet = {};

    for (var key in tetraShapes) {
      this._shapesSet[key] = tetraShapes[key];
    }

    if (additionalShapes) for (var _key in additionalShapes) {
      this._shapesSet[_key] = additionalShapes[_key];
    }
    this._gameStatus = GAME_STATUS.INIT;
    this._statistic = {
      countShapesFalled: 0,
      countShapesFalledByType: {},
      countLinesReduced: 0,
      countDoubleLinesReduced: 0,
      countTrippleLinesReduced: 0,
      countQuadrupleLinesReduced: 0
    };
    this._heap = [];

    if (defaultHeap && defaultHeap.length && defaultHeap[0].length) {
      for (var y = 0; y < defaultHeap.length; y++) {
        var row = [];

        for (var x = 0; x < this.width; x++) {
          row.push({
            val: 0
          });
        }

        this._heap.push(row);
      }

      var inversedDefaultHeap = defaultHeap.slice().reverse();

      for (var _y = 0; _y < inversedDefaultHeap.length && _y < this.height; _y++) {
        var _row = inversedDefaultHeap[_y];

        for (var _x = 0; _x < _row.length && _x < this.width; _x++) {
          this._heap[_y][_x].val = inversedDefaultHeap[_y][_x];
        }
      }
    }

    this._checkHeapForReduce();

    if (renderHandle) {
      renderHandle(this.state);
      this._renderHandle = renderHandle;
    }
  }
  /**
   * Creates a new Shape
   */


  _createClass(Engine, [{
    key: "_newFigure",
    value: function _newFigure() {
      this._shape = this._nextShape ? this._nextShape : new Shape(this._shapesSet, parseInt(this.width / 2 - 2), this.height);
      this._nextShape = new Shape(this._shapesSet, parseInt(this.width / 2 - 2), this.height);
      var countFalledShapesByThisKind = this._statistic.countShapesFalledByType[this._shape.name];
      if (!countFalledShapesByThisKind) this._statistic.countShapesFalledByType[this._shape.name] = 1;else this._statistic.countShapesFalledByType[this._shape.name]++;
      this._statistic.countShapesFalled++;
    }
    /**
     * Running a game or turn off a pause mode
     */

  }, {
    key: "start",
    value: function start() {
      if (this._gameStatus !== GAME_STATUS.INIT && this._gameStatus !== GAME_STATUS.PAUSE) return false;

      if (this._gameStatus == GAME_STATUS.INIT) {
        this._newFigure();

        this._gameStatus = GAME_STATUS.WORK;
        return true;
      }

      if (this._gameStatus == GAME_STATUS.PAUSE) {
        this._gameStatus = GAME_STATUS.WORK;
      }
    }
    /**
     * Turn on a pause mode
     */

  }, {
    key: "pause",
    value: function pause() {
      if (this._gameStatus !== GAME_STATUS.WORK) return false;
      this._gameStatus = GAME_STATUS.PAUSE;
      return true;
    }
  }, {
    key: "moveLeft",
    value: function moveLeft() {
      if (this._gameStatus !== GAME_STATUS.WORK) return;
      if (!this._canShapeMove(0, -1)) return;
      this._shape.position.X--;

      this._renderHandle(this.state);
    }
  }, {
    key: "moveRight",
    value: function moveRight() {
      if (this._gameStatus !== GAME_STATUS.WORK) return;
      if (!this._canShapeMove(0, 1)) return;
      this._shape.position.X++;

      this._renderHandle(this.state);
    }
  }, {
    key: "moveUp",
    value: function moveUp() {
      if (this._gameStatus !== GAME_STATUS.WORK) return;
      if (!this._canShapeMove(1, 0)) return;
      this._shape.position.Y++;

      this._renderHandle(this.state);
    }
  }, {
    key: "moveDown",
    value: function moveDown() {
      if (this._gameStatus !== GAME_STATUS.WORK) return;

      if (!this._canShapeMove(-1, 0)) {
        if (!this._addShapeToHeap()) {
          this._gameStatus = GAME_STATUS.OVER;

          this._renderHandle(this.state);
        }

        return;
      }

      this._shape.position.Y--;

      this._renderHandle(this.state);
    }
  }, {
    key: "_addShapeToHeap",
    value: function _addShapeToHeap() {
      var newRowForHeap = [];

      for (var i = 0; i < this.width; i++) {
        newRowForHeap.push({
          val: 0
        });
      }

      for (var y = ShapeDimension - 1; y >= 0; y--) {
        var row = this._shape.body[y];

        for (var x = 0; x < ShapeDimension; x++) {
          var cell = row[x];

          if (cell) {
            var areaIndexY = this._getAreaIndexYFromShape(y);

            if (areaIndexY >= this.height) {
              //game over :)
              return false;
            }

            while (areaIndexY >= this._heap.length) {
              this._heap.push(newRowForHeap.slice());
            }

            var areaIndexX = this._getAreaIndexXFromShape(x);

            this._heap[areaIndexY][areaIndexX] = {
              val: 1,
              class: this._shape.name
            };
          }
        }
      }

      this._checkHeapForReduce();

      this._newFigure();

      this._renderHandle(this.state);

      return true;
    }
  }, {
    key: "_checkHeapForReduce",
    value: function _checkHeapForReduce() {
      var linesToRemove = [];

      for (var y = this._heap.length - 1; y >= 0; y--) {
        var row = this._heap[y];
        var isThereEmptySquare = false;

        for (var x = 0; x < row.length; x++) {
          if (!this._heap[y][x].val) {
            isThereEmptySquare = true;
            break;
          }
        }

        if (!isThereEmptySquare) linesToRemove.push(y);
      }

      var newHeap = [];

      for (var _y2 = 0; _y2 < this._heap.length; _y2++) {
        if (linesToRemove.indexOf(_y2) == -1) newHeap.push(this._heap[_y2]);
      }

      this._statistic.countLinesReduced += linesToRemove.length;

      switch (linesToRemove.length) {
        case 2:
          this._statistic.countDoubleLinesReduced++;
          break;

        case 3:
          this._statistic.countTrippleLinesReduced++;
          break;

        case 4:
          this._statistic.countQuadrupleLinesReduced++;
          break;
      }

      this._heap = newHeap;
    }
  }, {
    key: "rotate",
    value: function rotate() {
      if (this._gameStatus !== GAME_STATUS.WORK) return;
      if (!this._canShapeMove(0, 0, this._shape.getRotatedBody())) return;

      this._shape.rotate();

      this._renderHandle(this.state);
    }
  }, {
    key: "rotateBack",
    value: function rotateBack() {
      if (this._gameStatus !== GAME_STATUS.WORK) return;
      if (!this._canShapeMove(0, 0, this._shape.getRotatedBackBody())) return;

      this._shape.rotateBack();

      this._renderHandle(this.state);
    }
  }, {
    key: "_getShapeIndexX",
    value: function _getShapeIndexX(x) {
      return x - this._shape.position.X;
    }
  }, {
    key: "_getShapeIndexY",
    value: function _getShapeIndexY(y) {
      return this._shape.position.Y + (ShapeDimension - 1) - y;
    }
  }, {
    key: "_getAreaIndexXFromShape",
    value: function _getAreaIndexXFromShape(shapeX) {
      var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return shapeX + this._shape.position.X + delta;
    }
  }, {
    key: "_getAreaIndexYFromShape",
    value: function _getAreaIndexYFromShape(shapeY) {
      var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._shape.position.Y + (ShapeDimension - 1) - shapeY + delta;
    }
    /**
     * Specifies that can a shape move. 
     * If new coordinates of shape overlap with coordinates of heap 
     * or are outside the game area the shape can't move
     * @param {*} deltaY specifies vertical moving distance
     * @param {*} deltaX specifies horizontal moving distance
     * @param {*} shapeBody specifies changed body of a shape, for example rotated body
     */

  }, {
    key: "_canShapeMove",
    value: function _canShapeMove(deltaY, deltaX, shapeBody) {
      if (!shapeBody) shapeBody = this._shape.body;

      for (var y = 0; y < shapeBody.length; y++) {
        var row = shapeBody[y];

        var areaIndexY = this._getAreaIndexYFromShape(y, deltaY);

        for (var x = 0; x < row.length; x++) {
          var cell = row[x];

          if (cell) {
            var areaIndexX = this._getAreaIndexXFromShape(x, deltaX); //check will the shape go over the walls and the ground


            if (areaIndexY < 0 || areaIndexX < 0 || areaIndexX >= this.width) return false;
            if (this._isHeapSquare(areaIndexY, areaIndexX)) return false;
          }
        }
      }

      return true;
    }
  }, {
    key: "_isShapeSquare",
    value: function _isShapeSquare(y, x) {
      if (!this._shape || !this._shape.body) return false;

      var row = this._shape.body[this._getShapeIndexY(y)];

      return row && row[this._getShapeIndexX(x)];
    }
  }, {
    key: "_isHeapSquare",
    value: function _isHeapSquare(y, x) {
      if (!this._heap) return false;
      return this._heap[y] && this._heap[y][x].val;
    }
  }, {
    key: "_getHeapClass",
    value: function _getHeapClass(y, x) {
      if (!this._heap) return;
      if (!this._heap[y] || !this._heap[y][x].val) return;
      return this._heap[y][x].class;
    }
  }, {
    key: "_getBody",
    value: function _getBody() {
      var body = [];

      for (var y = this.height - 1; y >= 0; y--) {
        var row = [];

        for (var x = 0; x < this.width; x++) {
          var isHeap = this._isHeapSquare(y, x);

          var isShape = this._isShapeSquare(y, x);

          var val = isHeap ? 2 : isShape ? 1 : 0;
          row.push({
            val: val,
            cssClasses: [isShape ? 'shape' : null, isHeap ? 'heap' : null, isShape ? this._shape.name + '' : null, isHeap ? this._getHeapClass(y, x) : null]
          });
        }

        body.push(row);
      }

      return body;
    }
  }, {
    key: "state",
    get: function get() {
      return {
        gameStatus: this._gameStatus,
        body: this._getBody(),
        shapeName: this._shape ? this._shape.name : null,
        nextShapeName: this._nextShape ? this._nextShape.name : null,
        nextShapeBody: this._nextShape ? this._nextShape.body : null,
        statistic: this._statistic
      };
    }
  }]);

  return Engine;
}();
/**
 * Enum represents status of a game
 * 
 * INIT - game was not started
 * WORK - game is running
 * PAUSE - game was temporary stopped
 * OVER - game was finished
 */


var GAME_STATUS = {
  INIT: 0,
  WORK: 1,
  PAUSE: 2,
  OVER: 3
};
module.exports = Engine;